<template>
  <div>

    <v-row>
      <v-col>
        <v-card elevation=0>
          <v-card-text class="d-flex align-center">
            <div class="flex-grow-1" style="font-size: 16px;">
              {{$t('menus.subscriptions.currentPlan')}}: <b>{{getSubscriptionName}}</b>
            </div>
            <div class="flex-grow-0">
              <v-btn color="primary" elevation=0 @click="openSubscriptionContactDialog">
                {{$t('menus.subscriptions.changePlan')}}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <v-row>
      <v-col>
        <v-card elevation=0>
          <v-card-text class="d-flex align-center">
            <div class="flex-grow-1" style="font-size: 16px;">
              {{$t('menus.subscriptions.creditsLeft')}}: <b>{{getCreditsLeft}}</b>
            </div>
            <div class="flex-grow-0">
              <ResourcesListDialog>
                <v-btn color="primary" elevation=0>
                  {{$t('menus.subscriptions.purchaseExtraCredits')}}
                </v-btn>
              </ResourcesListDialog>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import { useServiceStore } from '@/stores/ServiceStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import ResourcesListDialog from '../dialogs/ResourcesListDialog.vue'

export default {
  name: "PaidSubscriptionsPage",
  components: {
    ResourcesListDialog,
  },
  mounted() {
    this.refreshLimits();
  },
  methods: {
    openSubscriptionContactDialog() {
      const mainStore = useMainStore();
      mainStore.showSubscriptionContactDialog();
    },
    refreshLimits() {
      const payload = {
        accessPointId: this.accessPointId,
      };

      const serviceStore = useServiceStore();
      serviceStore.refreshLimits(payload);
    },
    getResourceStructure: function() {
      return {
        limit: 0,
        usage: 0,
        percentage: 0,
      }
    },
  },
  computed: {
    accessPointId: function() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getSubscriptionName() {
      const systemStore = useSystemStore();
      const subscription = systemStore.getSubscription;

      if (subscription && subscription.subscription && subscription.subscription.name) {
        return subscription.subscription.name;
      }

      return null;
    },
    getLimitByName() {
      return (limitName) => {
        let resource = this.getResourceStructure();

        if (!Array.isArray(this.getLimits)) {
          return resource;
        }

        let limit = this.getLimits.find(x => x.name == limitName);
        if (limit) {
          resource.limit = limit.limit;
          resource.usage = limit.spent;
          resource.percentage = limit.limit == 0 ? 0 : (limit.spent / limit.limit);
          resource.percentage = (resource.percentage * 100).toFixed(1);
        }

        return resource;
      };
    },

    getLimits: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getLimits;
    },
    getCreditsLimit: function() {
      return this.getLimitByName('credits');
    },
    getCreditsLeft() {
      if (this.getCreditsLimit) {
        return this.getCreditsLimit.limit - this.getCreditsLimit.usage;
      }

      return '';
    },
  },
}
</script>

<style>
</style>
